import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { createSafeContext } from "@components/mantine";
var ref = _sliced_to_array(createSafeContext("SourceIdentity component was not found in the tree"), 2);
export var SourceIdentityProvider = ref[0], useSourceIdentityContext = ref[1];

//# sourceMappingURL=SourceIdentityContext.js.map